import { createContext, useContext } from 'react';

import type Cropper from 'cropperjs';

import type { TranslationKey } from '@change-corgi/core/i18n';

import type { RawMediaCropInput } from 'src/app/shared/components/imageUpload';

import type { Action } from './actions';

type Dispatch = (action: Action) => void;

export type ImageUploadState = {
	image: string | undefined;
	imageChanged: boolean;
	imageCrop: RawMediaCropInput | undefined;
	errorMessage: TranslationKey | null;
	fileType: string | null;
	cropper: Cropper | undefined;
};

export type ImageUploadContextType = { state: ImageUploadState; dispatch: Dispatch };

export const ImageUploadContext = createContext<ImageUploadContextType | undefined>(undefined);

export function useImageUploadContext(): ImageUploadContextType {
	const context = useContext(ImageUploadContext);
	if (context === undefined) {
		throw new Error('useImageUploadContext must be used within a ImageUploadProvider');
	}
	return context;
}
